export var ScheduleMode;
(function (ScheduleMode) {
    ScheduleMode["SCHEDULE_MODE_UNSPECIFIED"] = "UNSPECIFIED";
    ScheduleMode["SCHEDULE_MODE_BASIC"] = "BASIC";
    ScheduleMode["SCHEDULE_MODE_ADVANCED"] = "ADVANCED";
})(ScheduleMode || (ScheduleMode = {}));
